import { render, staticRenderFns } from "./offer-original-price.vue?vue&type=template&id=131cf08e&scoped=true"
import script from "./offer-original-price.vue?vue&type=script&lang=js"
export * from "./offer-original-price.vue?vue&type=script&lang=js"
import style0 from "./offer-original-price.vue?vue&type=style&index=0&id=131cf08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131cf08e",
  null
  
)

export default component.exports